import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";

const DatePicker = ({ startDate, endDate, zIndex, index = null }) => {
  const dispatch = useDispatch();
  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.leadActivity.currentUser
  );

  const handleUpdateDates = (startDate, endDate) => {
    const payload = {
      key: "selectedRequestDates",
      data: { startDate, endDate }
    };
    if (index == null) {
      return dispatch(actionCreators.updateMainFilter(payload));
    }

    dispatch(actionCreators.updateFilterByIndex({ ...payload, index }));
  };

  return (
    <div className="date-select-box select-box multi" style={{ zIndex }}>
      <p className="offers-title">Date</p>
      <ReactDatePicker
        startDate={startDate}
        endDate={endDate}
        calendarEndDate={calendarEndDate}
        isRangePicker
        minDate={calendarStartDate}
        updateDates={handleUpdateDates}
      />
    </div>
  );
};

export default DatePicker;
